export default "__VITE_ASSET__0b243ecf__"